import { useState, useEffect } from 'react';
import { DomainConfig, getCurrentDomainConfig } from '../config/domains';

export const useDomainConfig = () => {
  const [config, setConfig] = useState<DomainConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('useDomainConfig: Getting domain config...');
    const domainConfig = getCurrentDomainConfig();
    console.log('useDomainConfig: Domain config result:', domainConfig);
    setConfig(domainConfig);
    setLoading(false);
  }, []);

  return { config, loading };
};